import axios, {
  AxiosError,
  AxiosResponse,
  InternalAxiosRequestConfig,
} from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request Interceptor
apiClient.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    const safeConfig = { ...config };

    // Redact sensitive data in logs
    if (safeConfig.data && typeof safeConfig.data === 'object' && 'password' in safeConfig.data) {
      safeConfig.data = { ...safeConfig.data, password: '[REDACTED]' };
    }

    console.debug('API Request:', safeConfig);
    return config;
  },
  (error: AxiosError) => {
    console.error('API Request Error:', error);
    return Promise.reject(error);
  }
);

// Response Interceptor
apiClient.interceptors.response.use(
  (response: AxiosResponse) => {
    console.debug('API Response:', response);
    return response;
  },
  (error: AxiosError) => {
    console.error('API Response Error:', error);

    // Handle 401 (unauthenticated)
    if (error.response?.status === 401) {
      localStorage.removeItem('auth_status');
      window.location.href = '/login';
    }

    if (!error.response) {
      throw new Error('Network error - please check your connection');
    }

    // Structured error with optional extensions
    const apiError = new Error(
      (error.response.data as any)?.error || 'An unexpected error occurred'
    ) as Error & { status?: number; details?: any };

    apiError.status = error.response.status;
    apiError.details = (error.response.data as any)?.details;

    throw apiError;
  }
);

export default apiClient;
